export default __webpack_public_path__ + "static/media/loader.baae81b7.gif";